import PeoopleMap from './map';

export default PeoopleMap;
